import { oracleTestimonial } from "@/content/testimonials";

export function ClientTestimonial() {
  return (
    <section aria-labelledby="client-testimonial-heading" className="border-y border-border bg-card/80">
      <div className="container mx-auto max-w-7xl px-6 py-16 lg:px-10 lg:py-24">
        <div className="row g-5 align-items-start">
          <div className="col-lg-4">
            <p className="demo-section-label">Client testimonial</p>
            <h2 id="client-testimonial-heading" className="site-heading-md mt-4 font-display font-light">
              A website Oracle is <em>proud to share</em>
            </h2>
          </div>
          <div className="col-lg-8">
            <figure className="m-0">
              <blockquote className="site-copy space-y-6 text-foreground">
                {oracleTestimonial.paragraphs.map((paragraph) => (
                  <p key={paragraph}>{paragraph}</p>
                ))}
              </blockquote>
              <figcaption className="mt-8 border-t border-border pt-6 text-sm leading-relaxed">
                <span className="block font-semibold text-foreground">{oracleTestimonial.name}</span>
                <span className="text-muted-foreground">
                  {oracleTestimonial.role}, {oracleTestimonial.company}
                </span>
              </figcaption>
            </figure>
          </div>
        </div>
      </div>
    </section>
  );
}
